module.exports = __webpack_public_path__ + "img/VEH.2946144.svg";